module.exports = __webpack_public_path__ + "static/media/btcp.c94efc1f.svg";